import {
  allowcateRequest,
  importAllocationDetail,
  updateStatusDetail,
} from 'interface/allowcate.interface';
import axiosClient from './axiosClient';

const path = 'abe/capital-branch';

const AllocateApi = {
  createAllocation: (params?: allowcateRequest): Promise<any> => {
    return axiosClient.post(`/${path}/create-allocation`, params);
  },
  importAllocationDetail: (params?: importAllocationDetail): Promise<any> => {
    return axiosClient.post(`/${path}/import-allocation-details`, params);
  },
  saveDraftAllocate: (capital_branch_id?: number): Promise<any> => {
    return axiosClient.put(`/${path}/save-as-draft`, { capital_branch_id });
  },
  saveAllocate: (param?: any): Promise<any> => {
    return axiosClient.put(`/${path}/save-as-draft-and-allocate`, {
      capital_branch_id: param?.capitalBranchId,
      status: param?.status,
    });
  },
  getAllocation: (params?: any): Promise<any> => {
    return axiosClient.get(`/${path}`, { params });
  },
  getAllocationDetails: (capital_branch_id?: number): Promise<any> => {
    return axiosClient.get(`/${path}/${capital_branch_id}`);
  },
  getCapitalAllocation: (
    capital_branch_id?: number,
    params?: any
  ): Promise<any> => {
    return axiosClient.get(`/${path}/${capital_branch_id}/list-detail`, {
      params,
    });
  },
  updateStatusListDetails: (params?: updateStatusDetail): Promise<any> => {
    return axiosClient.put(`/${path}/update-status-list-details`, {
      capital_branch_id: params?.capital_branch_id,
      list_shop_ids: params?.list_shop_ids,
      status: params?.status,
    });
  },
  getDetailByBranchCode: (
    branch_code?: string,
    capital_year?: number
  ): Promise<any> => {
    const params = { branch_code: branch_code, capital_year: capital_year };
    return axiosClient.get(`/${path}/get-detail-by-branch-code`, {
      params,
    });
  },
  updateAllocationInfo: (params?: any): Promise<any> => {
    const apiJson = {
      capital_year: params?.capital_year,
      branch_id: params?.branch_id,
      capital_name: params?.capital_name,
      capital_value: params?.total_capital_value,
      capital_branch_id: params?.capital_branch_id,
    };
    return axiosClient.put(`/${path}/update-allocation-info`, apiJson);
  },

  getMaxCapitalYear: (branch_code?: string): Promise<any> => {
    return axiosClient.get(`/${path}/max-capital-year`, {
      params: { branch_code },
    });
  },

  getOptionList: (): Promise<any> => {
    return axiosClient.get('abe/plant/options-list');
  },
};

export default AllocateApi;
